import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, finalize, throwError } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { AuthUtility } from '../utility/auth-utility';
import { AppService } from '../services/app-service';
import { Constante } from '../../constante';

export const appInterceptor: HttpInterceptorFn = (request, next) => {

    // custom request
    var customRequest = request.clone();

    if (AuthUtility.isAuthenticated()) {
        customRequest = request.clone({
            headers: request.headers.set('Authorization', 'Bearer ' + AuthUtility.getToken())
        });
    }

    // error control
    const appService = inject(AppService);
    const toastr = inject(ToastrService);
    const router = inject(Router);
    const _const = Constante;

    //return next(customRequest);

    //appService.activateLoading();
    return next(customRequest).pipe(
        finalize(() => {
            //appService.deactivateLoading();
        }),
        catchError((error) => {
            console.error(_const.MESSAGE_ERROR_SERVER, error);

            if (!request.headers.has('Skip-Toast')) {
                let errorMsg = _const.MESSAGE_ERROR_SERVER;
                if (error && error.error) {
                    let errBody = error.error;
                    if (typeof errBody === 'string') {
                        try {
                            errBody = JSON.parse(errBody);
                        } catch (e) {}
                    }
                    if (errBody && typeof errBody === 'object') {
                        if (errBody.errors && Array.isArray(errBody.errors) && errBody.errors.length > 0) {
                            const messages = errBody.errors
                                .map((e: any) => e.message || e.description || '')
                                .filter(Boolean);
                            if (messages.length > 0) {
                                errorMsg = messages.join(' | ');
                            } else if (errBody.message) {
                                errorMsg = errBody.message;
                            }
                        } else if (errBody.message) {
                            errorMsg = errBody.message;
                        }
                    }
                }
                toastr.error(errorMsg, _const.MESSAGE_TITLE_ERROR);
            }

            if (error.status == 401) {
                if (!request.headers.has('Skip-Toast')) {
                    toastr.error("Su sesión ha caducado", _const.MESSAGE_TITLE_INFO);
                }
                AuthUtility.closeSessionData();
                router.navigate(['/login']);
            }

            return throwError(() => error);
        })
    );
};
